<template>
  <div>
    <!-- 消息提醒 -->
    <ul class="remindBox w clearfix manage-home">
      <!-- 新消息提醒 -->
      <li>
        <div class="remindBox-tit clearfix">
          <span class="kind-title">申请管理</span>
        </div>
        <div class="manage-con-box">
          <p class="sq-title">
            <img src="@/assets/images/manage/applyFor.png" alt="">
            <span>新申请的理财顾问</span>
          </p>
<!--          gray-->
          <div class="hint-box">
            <p class="left">
              <span class="spot"></span>
              <span class="word">您有3条申请需要处理</span>
            </p>
            <p span="day">2023-11-28</p>
          </div>
        </div>
      </li>
      <!-- 近期待办提醒 -->
      <li>
        <div class="remindBox-tit clearfix">
          <span class="kind-title">消息管理</span>
        </div>
        <div class="manage-con-box con-subfield">
          <div>
            <p class="sq-title">
              <img src="@/assets/images/manage/callback.png" alt="">
              <span>待回访客户</span>
            </p>
            <div class="hint-box">
              <p class="left">
                <span class="spot gray"></span>
                <span class="word">您有3条申请需要处理</span>
              </p>
              <p span="day">2023-11-28</p>
            </div>
          </div>
          <div>
            <p class="sq-title">
              <img src="@/assets/images/manage/demand.png" alt="">
              <span>新申请客户</span>
            </p>
            <div class="hint-box">
              <p class="left">
                <span class="spot"></span>
                <span class="word">您有3条申请需要处理</span>
              </p>
              <p span="day">2023-11-28</p>
            </div>

          </div>
        </div>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  data () {
    return {
      privateFunds: [],
      publicFunds: [],
      siteAnnouncementLists: [],
      newMessageLists: [],
      newCount: '--',
      totalCount: '--',
      salesCount: '--',
      totalSalesCount: '--',
      dialogVisable: true,
      notebookLists: [],//笔记本
      // 提醒数量
      messageCount: '--',
      notebookCount: '--',
    }
  },
  created () {
    // 是否为初始密码
    let resetPass = this.$commonJs.getCookie("Password")
    this.dialogVisable = resetPass == "+s9ntqZqZEHrXpsBArmjaQ==" ? true : false
  },
  mounted () {
    this.getNoteBook()
    this.getNewMessage()
  },
  methods: {
    // 记事本列表
    getNoteBook () {
      this.$http.post(this.$apiPath.getInvestmentAdviserNoteBook, {
        AdviserCode: this.$commonJs.getCookie('code'),
        Content: '',
        Date: '',
        Type: "",
        Solved: "待处理",
        OrderBy: "endDate",
        Arrow: 1,
        Page: 1,
        PageNum: 5,
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          res.data.data.list.forEach(item => {
            if (item.type == "基金交易") {
              item.con = item.fundName + '(' + item.fundCode + ')基金' + item.content
            } else if (item.type == "普通记事") {
              item.con = item.content
            } else {
              item.con = item.content
            }
          })
          this.notebookLists = res.data.data.list
          this.notebookCount = res.data.data.recordCount
        }
      }).catch(err => { })

    },
    // 新消息提示
    getNewMessage () {
      this.$http.post(this.$apiPath.newMessage, {
        AdviserCode: this.$commonJs.getCookie('code'),
      }).then(res => {
        console.log('1212',res);
        if (res.data.code == 200) {
          this.messageCount = res.data.data.dataList.length
          this.newMessageLists = res.data.data.dataList.slice(0, 5)
        }
      }).catch(err => { })
    }
  },
}
</script>

<style lang="less" scoped>
.remindBox {
  margin: 12px 0;
  height: 210px;
  li {
    padding: 20px;
    box-sizing: border-box;
    float: left;
    width: 438px;
    height: 100%;
    margin-right: 12px;
    background: @wColor;
    border-radius: 3px;
    border-radius: 15px;
  }
  li:last-child {
    margin-right: 0;
    width:748px;
  }
  &-tit {
    padding-bottom: 15px;
    border-bottom: 1px solid @colorD;
    &-tips {
      font-size: 16px;
      font-weight: bold;
      color: @color;
      margin-left: 5px;
    }
  }
  &-con {
    margin-top: 8px;
    p {
      position: relative;
      padding-left: 26px;
      height: 28px;
      line-height: 28px;
      overflow: hidden;
      span:nth-child(1) {
        display: inline-block;
        width: 255px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: @color3;
      }
      span:nth-child(2) {
        float: right;
        font-size: 12px;
        color: @color6;
      }
    }
    p::before {
      position: absolute;
      left: 8px;
      top: 12px;
      content: "";
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: @colorbg4;
    }
  }
}
.manage-home{
  .kind-title{
    font-size: 20px;
    font-weight: bold;
    color: @color;
    line-height: 30px;
  }
  .manage-con-box{
    padding:25px 10px;
    .sq-title{
      font-size: 18px;
      font-weight: 500;
      color: @color3;
      line-height: 30px;
      img{
        width:22px;
        height: 22px;
        margin-right:12px;
      }
    }
    .hint-box{
      display: flex;
      padding:14px 10px;
      justify-content: space-between;
      line-height: 30px;
      .left{
        font-size: 18px;
        font-weight: 500;
        color: @color3;
        .spot{
          display: inline-block;
          width: 12px;
          height: 12px;
          background: linear-gradient(0deg, @color71D 0%, @colorF42 100%);
          border-radius: 50%;
          margin-right: 12px;
        }
        .gray{
          background: linear-gradient(0deg, @color96 0%, @colorDC 100%);
        }
      }

      .day{
        font-size: 14px;
        font-weight: 400;
        color: @color6;
      }
    }
  }
  .con-subfield{
    display: flex;
    >div{
      width:50%;
    }
  }
}
</style>
